package ui.pages

import web.cssom.px

object Sizes {
    object Header {
        const val HEIGHT_NOT_PX = 64
        val Height = HEIGHT_NOT_PX.px
    }

    object Footer {
        val Height = 30.px
    }
}